import React from "react";
import type { DeviceConnection } from "../../../api/deviceConnection";
import { AllDataDevice } from "../../../generated/types";
import {
  DataTable,
  DataTableSkeletonRows,
  DataTableSort,
} from "../../common/DataTable";
import { DeviceColumnKey, DeviceRow, useDeviceColumns } from "./DeviceRow";

type DevicesTableContentProps = {
  devices: AllDataDevice[];
  isLoading: boolean;
  favorites: string[];
  selectedUuid: string;
  onSelectDevice: (device: AllDataDevice) => void;
  onToggleFavorite: (uuid?: string) => (e: React.MouseEvent) => void;
  onViewDevice: (uuid: string) => (e: React.MouseEvent) => void;
  sort?: DataTableSort<DeviceColumnKey>;
  onSort: (key: DeviceColumnKey) => void;
  scrollKey: string;
  /** Colonne UUID, affichée hors espace admin (cf. useDeviceColumns). */
  showUuid?: boolean;
  /** État de connexion VPN, indexé par uuid (useDeviceConnections). */
  connections?: Record<string, DeviceConnection>;
};

export const DevicesTableContent = ({
  devices,
  isLoading,
  favorites,
  selectedUuid,
  onSelectDevice,
  onToggleFavorite,
  onViewDevice,
  sort,
  onSort,
  scrollKey,
  showUuid = false,
  connections = {},
}: DevicesTableContentProps) => {
  const columns = useDeviceColumns(showUuid);

  return (
    <DataTable
      columns={columns}
      scrollKey={scrollKey}
      sort={sort}
      onSort={onSort}
    >
      {isLoading ? (
        <DataTableSkeletonRows columns={columns} />
      ) : (
        devices
          .filter((device) => !!device?.device)
          .map((device) => {
            const uuid = device.device.uuid;
            return (
              <DeviceRow
                key={uuid || String(device.device.id)}
                device={device}
                isFavorite={!!uuid && favorites.includes(uuid)}
                onToggleFavorite={onToggleFavorite(uuid)}
                onClick={() => onSelectDevice(device)}
                onViewDevice={onViewDevice(uuid)}
                showUuid={showUuid}
                connection={connections[uuid]}
                selected={uuid === selectedUuid}
              />
            );
          })
      )}
    </DataTable>
  );
};
